import { getBookLink, getBooksLink } from '@livv/utils/helpers';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import { useBookPageContext } from '@utils/context/book';
import { sxs } from '@utils/mui/sx';

const breadcrumbsTextSx = {
    color: 'grey.400',
    display: 'flex',
    fontSize: 11,
    lineHeight: 1,
};

const NavBreadcrumbs: FC = () => {
    const { bookId, bookMeta } = useBookPageContext();
    const { t } = useTranslation('navBar');

    return (
        <Breadcrumbs
            aria-label="breadcrumb"
            data-test-id="nav-breadcrumbs"
            separator={<NavigateNextIcon fontSize="small" />}
            sx={sxs([{ mb: 2 }, breadcrumbsTextSx])}
        >
            <Typography sx={breadcrumbsTextSx}>{t('link.legalTools')}</Typography>
            <Link color="inherit" href={getBooksLink()} sx={breadcrumbsTextSx} underline="hover">
                {t('link.books')}
            </Link>
            <Link
                color="inherit"
                href={getBookLink({ bookId })}
                sx={breadcrumbsTextSx}
                underline="hover"
            >
                {bookMeta.title}
            </Link>
        </Breadcrumbs>
    );
};

export default NavBreadcrumbs;
